"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _axios = _interopRequireDefault(require("axios"));

var _lodash = _interopRequireDefault(require("lodash"));

var _basic = _interopRequireDefault(require("./_basic"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var PGSqlApi =
/*#__PURE__*/
function (_BasicApi) {
  (0, _inherits2.default)(PGSqlApi, _BasicApi);

  /**
   * Represents a Tables Api.
   * @constructor
   */
  function PGSqlApi(_ref) {
    var _this;

    var userTokenFactory = _ref.userTokenFactory,
        PGSqlUrl = _ref.PGSqlUrl,
        accountIdFactory = _ref.accountIdFactory,
        timeout = _ref.timeout;
    (0, _classCallCheck2.default)(this, PGSqlApi);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PGSqlApi).call(this, {
      userTokenFactory: userTokenFactory,
      accountIdFactory: accountIdFactory
    }));
    _this.PGSqlUrl = PGSqlUrl;
    _this.axios = _axios.default.create(_objectSpread({}, timeout && {
      timeout: timeout
    }, {
      baseURL: "".concat(PGSqlUrl, "/").concat(_this.accountIdFactory),
      headers: {
        Authorization: _this.userToken,
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }));
    return _this;
  }

  (0, _createClass2.default)(PGSqlApi, [{
    key: "_callApi",
    value: function () {
      var _callApi2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(_ref2) {
        var url, data, method, _ref3, res;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = _ref2.url, data = _ref2.data, method = _ref2.method;
                _context.next = 3;
                return this.axios({
                  url: "".concat(this.PGSqlUrl, "/").concat(this.accountIdFactory, "/").concat(url),
                  method: method,
                  data: data,
                  headers: {
                    Authorization: this.userToken,
                    'Content-Type': 'application/json;charset=UTF-8'
                  }
                }).catch(function (e) {
                  var response = _lodash.default.get(e, 'response.data', e);

                  var err = new Error(response.message);
                  err.data = response;
                  throw err;
                });

              case 3:
                _ref3 = _context.sent;
                res = _ref3.data;
                return _context.abrupt("return", res);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _callApi(_x) {
        return _callApi2.apply(this, arguments);
      }

      return _callApi;
    }()
    /**
     * @param {String} param0.query cypher query for graph db
     * @param {Object} param0.params Object with params to query 
     * @param {String} param0.database Database name
     */

  }, {
    key: "executeQuery",
    value: function () {
      var _executeQuery = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(_ref4) {
        var query, params, database;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                query = _ref4.query, params = _ref4.params, database = _ref4.database;
                return _context2.abrupt("return", this._callApi({
                  data: {
                    query: query,
                    params: params,
                    database: database
                  },
                  method: 'post',
                  url: 'query'
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function executeQuery(_x2) {
        return _executeQuery.apply(this, arguments);
      }

      return executeQuery;
    }()
    /**
     * 
     * @returns {Array} database names
     */

  }, {
    key: "listDatabases",
    value: function () {
      var _listDatabases = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3() {
        var _ref5, databases;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._callApi({
                  method: 'get',
                  url: 'databases'
                });

              case 2:
                _ref5 = _context3.sent;
                databases = _ref5.databases;
                return _context3.abrupt("return", databases);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function listDatabases() {
        return _listDatabases.apply(this, arguments);
      }

      return listDatabases;
    }()
    /**
     * 
     * @param {String} param0.database database name
     */

  }, {
    key: "createDatabase",
    value: function () {
      var _createDatabase = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(_ref6) {
        var database;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                database = _ref6.database;
                return _context4.abrupt("return", this._callApi({
                  data: {
                    database: database
                  },
                  method: 'put',
                  url: 'databases'
                }));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function createDatabase(_x3) {
        return _createDatabase.apply(this, arguments);
      }

      return createDatabase;
    }()
    /**
     * 
     * @param {String} param0.database database name
     */

  }, {
    key: "getDatabaseInfo",
    value: function () {
      var _getDatabaseInfo = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(_ref7) {
        var database;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                database = _ref7.database;
                return _context5.abrupt("return", this._callApi({
                  method: 'get',
                  url: "databases/".concat(encodeURIComponent(database))
                }));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getDatabaseInfo(_x4) {
        return _getDatabaseInfo.apply(this, arguments);
      }

      return getDatabaseInfo;
    }()
    /**
     * 
     * @param {String} param0.database database name
     */

  }, {
    key: "dropDatabase",
    value: function () {
      var _dropDatabase = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(_ref8) {
        var database;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                database = _ref8.database;
                return _context6.abrupt("return", this._callApi({
                  data: {
                    database: database
                  },
                  method: 'delete',
                  url: 'databases'
                }));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function dropDatabase(_x5) {
        return _dropDatabase.apply(this, arguments);
      }

      return dropDatabase;
    }()
  }]);
  return PGSqlApi;
}(_basic.default);

var _default = PGSqlApi;
exports.default = _default;